import React from "react";

import EngineLoader from "$components/loaders/engine-loader";
import InfoList from "../../info-list";

import { OpportunityStore } from "../../../stores/opportunities";
import { buildContent } from "../lib/helpers";

const MyClientsPanel = () => {
    const revenueData = OpportunityStore.useState((s) => s.myClients);
    if (!revenueData) {
        return <EngineLoader />;
    }

    return (
        <InfoList
            data={revenueData.map((s) => {
                return buildContent(s);
            })}
        />
    );
};

export default MyClientsPanel;
